import { FileBrowser } from '../../../components/FileBrowser/FileBrowser';

export function SecurePharmReportsPage() {
  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <FileBrowser catalog="spr" />
    </div>
  );
}
